import { COLORS } from '@app/src/ui';
import * as BgInmuebles from '@app/src/assets/img/bg-inmuebles.jpg';
import * as BgEducacion from '@app/src/assets/img/bg-educacion.jpg';
import * as BgVehiculos from '@app/src/assets/img/bg-vehiculos.jpg';
import * as BgEmpleos from '@app/src/assets/img/bg-empleos.jpg';
import * as BgOportunidades from '@app/src/assets/img/bg-oportunidades.jpg';
import * as PaymentSuccessProperty from '@app/src/assets/img/payment-success-property.png';
import * as PaymentSuccessEmployment from '@app/src/assets/img/payment-success-employment.png';
import * as PaymentSuccessOportunity from '@app/src/assets/img/payment-success-oportunity.png';
import * as PaymentSuccessVehicle from '@app/src/assets/img/payment-success-vehicle.png';
import * as PaymentSuccessEducation from '@app/src/assets/img/payment-success-education.png';

export enum CATEGORY_ALIAS {
  INMUEBLE = 'inmueble',
  EMPLEO = 'empleo',
  VEHICULO = 'vehiculo',
  EDUCACION = 'educacion',
  OPORTUNIDAD = 'oportunidad'
}

export enum CATEGORY_ID {
  INMUEBLE = 1,
  EMPLEO = 2,
  VEHICULO = 5,
  EDUCACION = 3,
  OPORTUNIDAD = 4
}

export const CATEGORY = {
  1: CATEGORY_ALIAS.INMUEBLE,
  2: CATEGORY_ALIAS.EMPLEO,
  3: CATEGORY_ALIAS.EDUCACION,
  4: CATEGORY_ALIAS.OPORTUNIDAD,
  5: CATEGORY_ALIAS.VEHICULO
}

export const CATEGORIES = {
  'inmueble': {
    id: 1,
    order: 1,
    active: true,
    name: 'Inmuebles',
    nameAlias: 'inmuebles',
    alias: CATEGORY_ALIAS.INMUEBLE,
    icon: 'icon-buildings',
    color: COLORS.GREEN,
    colorRgb: 'rgba(122, 162, 42, 0.2)',
    colorRgba: '153, 204, 51',
    backgroundRgb: 'rgba(244, 251, 239, 0.9);',
    colorIcon: 'rgb(153,204,51,.4)',
    bgImage: BgInmuebles,
    successImage: PaymentSuccessProperty,
    paths: {
      purchasePrint: {
        stepOne: '/publica-tu-inmueble-paso-1',
        stepTypePublication: '/publica-tu-inmueble-medio-de-publicacion',
        stepCalendar: '/publica-tu-inmueble-calendario',
        stepExtracharge: '/publica-tu-inmueble-extracargo',
        stepSummary: '/publica-tu-inmueble-vista-previa',
        stepFacturation: '/publica-tu-inmueble-facturacion'
      },
      consumePackage: {
        stepOne: '/publica-tu-inmueble-paq-paso-1',
        stepTypePublication: '/publica-tu-inmueble-paq-medio-de-publicacion',
        stepCalendar: '/publica-tu-inmueble-paq-calendario',
        stepExtracharge: '/publica-tu-inmueble-paq-extracargo',
        stepSummary: '/publica-tu-inmueble-paq-vista-previa',
        stepFacturation: '/publica-tu-inmueble-paq-facturacion',
        stepPrintPublished: '/publica-tu-inmueble-paq-confirmacion-de-publicacion'
      },
      purchasePackage: {
        stepSelection: '/compra-tu-paquete-inmuebles',
        stepFacturation: {
          talan: '/pago-paquete-tl-inmuebles',
          comercioTalan: '/pago-paquete-ec-tl-inmuebles',
          comercio: '/pago-paquete-ec-inmuebles'
        },
        stepFacturationConfirm: {
          success: {
            talan: '/confirmacion-de-pago-paquete-tl-inmuebles',
            comercioTalan: '/confirmacion-de-pago-paquete-ec-tl-inmuebles',
            comercio: '/confirmacion-de-pago-paquete-ec-inmuebles'
          },
          pending: {
            talan: '/pendiente-de-pago-paquete-tl-inmuebles',
            comercioTalan: '/pendiente-de-pago-paquete-ec-tl-inmuebles',
            comercio: '/pendiente-de-pago-paquete-ec-inmuebles'
          }
        }
      },
      facebook: 'https://www.facebook.com/elcomercio.clasificados/'
    },
    textPublish: 'tu inmueble',
    modalExample: {
      title: 'Miraflores',
      content: '3dorm. 2baños completos c/B.Servicio, cochera, depósito, terraza, 140mt2 1erPiso $260,000.00 C.998654556'
    },
    highLights: [
      {
        text: 'Ventas o Alquiler',
        description: 'Casas, departamentos, locales, oficinas, terrenos, propiedades, habitación, predios, locales industriales, hoteles, playas y otros.',
      },
      {
        text: 'Compras',
        description: 'Casas, departamentos, locales, terrenos, playas y propiedades.',
      },
      {
        text: 'Traspaso',
        description: ''
      },
      {
        text: 'Decoración y muebles',
        description: '',
      }
    ],
    highLightsSummary: {
      text: 'Venta, alquiler, compra, traspaso',
      description: [
        'Casas',
        'Departamentos',
        'Locales',
        'Oficinas',
        'Terrenos',
        'Habitación',
        'Hoteles, playas y otros',
        'Descoración y muebles'
      ]
    },
    discountMessage: 'Aprovecha los descuentos desde 5%, 12% y 25% a partir de 3, 5 y 10 publicaciones.'
  },
  'vehiculo': {
    id: 5,
    order: 2,
    active: true,
    name: 'Vehículos',
    nameAlias: 'vehiculos',
    alias: CATEGORY_ALIAS.VEHICULO,
    icon: 'icon-vehicle',
    color: COLORS.AMBAR,
    colorRgb: 'rgba(176, 112, 0, 0.2)',
    colorRgba: '217, 138, 0',
    backgroundRgb: 'rgba(250, 245, 235, 0.8)',
    colorIcon: 'rgb(217,138,0,.4)',
    bgImage: BgVehiculos,
    successImage: PaymentSuccessVehicle,
    paths: {
      purchasePrint: {
        stepOne: '/publica-tu-vehiculo-paso-1',
        stepTypePublication: '/publica-tu-vehiculo-medio-de-publicacion',
        stepCalendar: '/publica-tu-vehiculo-calendario',
        stepExtracharge: '/publica-tu-vehiculo-extracargo',
        stepSummary: '/publica-tu-vehiculo-vista-previa',
        stepFacturation: '/publica-tu-vehiculo-facturacion'
      },
      consumePackage: {
        stepOne: '/publica-tu-vehiculo-paq-paso-1',
        stepTypePublication: '/publica-tu-vehiculo-paq-medio-de-publicacion',
        stepCalendar: '/publica-tu-vehiculo-paq-calendario',
        stepExtracharge: '/publica-tu-vehiculo-paq-extracargo',
        stepSummary: '/publica-tu-vehiculo-paq-vista-previa',
        stepFacturation: '/publica-tu-vehiculo-paq-facturacion',
        stepPrintPublished: '/publica-tu-vehiculo-paq-confirmacion-de-publicacion'
      },
      purchasePackage: {
        stepSelection: '/compra-tu-paquete-vehiculos',
        stepFacturation: {
          talan: '/pago-paquete-tl-vehiculos',
          comercioTalan: '/pago-paquete-ec-tl-vehiculos',
          comercio: '/pago-paquete-ec-vehiculos'
        },
        stepFacturationConfirm: {
          success: {
            talan: '/confirmacion-de-pago-paquete-tl-vehiculos',
            comercioTalan: '/confirmacion-de-pago-paquete-ec-tl-vehiculos',
            comercio: '/confirmacion-de-pago-paquete-ec-vehiculos'
          },
          pending: {
            talan: '/pendiente-de-pago-paquete-tl-vehiculos',
            comercioTalan: '/pendiente-de-pago-paquete-ec-tl-vehiculos',
            comercio: '/pendiente-de-pago-paquete-ec-vehiculos'
          }
        }
      },
      facebook: 'https://www.facebook.com/elcomercio.clasificados/'
    },
    textPublish: 'tu vehículo',
    modalExample: {
      title: 'AUDI A3 SEDAN 2015',
      content: 'Automática Gas GLP $24000 excelente estado, único dueño, full/equipo, lunas y pestillos eléctricos, poco recorrido de km, todos los mantenimient en el concesionario de la marca C987654321'
    },
    highLights: [
      {
        text: 'Venta de Autos',
        description: 'Sedán, hatchbacks, camionetas suv, pickups y deportivos.'
      },
      {
        text: 'Otros Vehículos',
        description: 'Motos, camiones, buses, máquinas, motores y embarcaciones.'
      }
    ],
    highLightsSummary: {
      text: 'Venta de autos, otros vehículos',
      description: [
        'Sedán',
        'Hatchbacks',
        'Camionetas suv',
        'Pickups y deportivos',
        'Motos',
        'Camiones',
        'Buses',
        'Máquinas',
        'Motores',
        'Embarcaciones'
      ]
    },
    discountMessage: 'Aprovecha los descuentos desde 5%, 12% y 25% a partir de 3, 5 y 10 publicaciones. Y si publicas en 3 domingos en El Comercio y El Talán el mismo día obtendrás un descuento del 33%.'
  },
  'empleo': {
    id: 2,
    order: 3,
    active: true,
    name: 'Empleos',
    nameAlias: 'empleos',
    alias: CATEGORY_ALIAS.EMPLEO,
    icon: 'icon-briefcase',
    color: COLORS.BLUE,
    colorRgb: 'rgba(54, 124, 175, 0.2)',
    colorRgba: '103, 182, 240',
    colorIcon: 'rgb(103,182,240,.4)',
    backgroundRgb: 'rgba(238, 242, 245, 0.9)',
    bgImage: BgEmpleos,
    successImage: PaymentSuccessEmployment,
    paths: {
      purchasePrint: {
        stepOne: '/publica-tu-empleo-paso-1',
        stepTypePublication: '/publica-tu-empleo-medio-de-publicacion',
        stepCalendar: '/publica-tu-empleo-calendario',
        stepExtracharge: '/publica-tu-empleo-extracargo',
        stepSummary: '/publica-tu-empleo-vista-previa',
        stepFacturation: '/publica-tu-empleo-facturacion'
      },
      consumePackage: {
        stepOne: '/publica-tu-empleo-paq-paso-1',
        stepTypePublication: '/publica-tu-empleo-paq-medio-de-publicacion',
        stepCalendar: '/publica-tu-empleo-paq-calendario',
        stepExtracharge: '/publica-tu-empleo-paq-extracargo',
        stepSummary: '/publica-tu-empleo-paq-vista-previa',
        stepFacturation: '/publica-tu-empleo-paq-facturacion',
        stepPrintPublished: '/publica-tu-empleo-paq-confirmacion-de-publicacion'
      },
      purchasePackage: {
        stepSelection: '/compra-tu-paquete-empleos',
        stepFacturation: {
          talan: '/pago-paquete-tl-empleos',
          comercioTalan: '/pago-paquete-ec-tl-empleos',
          comercio: '/pago-paquete-ec-empleos'
        },
        stepFacturationConfirm: {
          success: {
            talan: '/confirmacion-de-pago-paquete-tl-empleos',
            comercioTalan: '/confirmacion-de-pago-paquete-ec-tl-empleos',
            comercio: '/confirmacion-de-pago-paquete-ec-empleos'
          },
          pending: {
            talan: '/pendiente-de-pago-paquete-tl-empleos',
            comercioTalan: '/pendiente-de-pago-paquete-ec-tl-empleos',
            comercio: '/pendiente-de-pago-paquete-ec-empleos'
          }
        }
      },
      facebook: 'https://www.facebook.com/elcomercio.clasificados/'
    },
    textPublish: 'empleos',
    modalExample: {
      title: 'Asistente Administrativo',
      content: 'Área cobranzas experiencia 2años disponibilidad inmediata. CV indicando pretensiones salariales selección@rrhh.com'
    },
    highLights: [
      {
        text: 'Ofrecidos, Pedidos',
        description: 'Profesionales, oficios y servicios domésticos.'
      },
      {
        text: 'Desplegados',
        description: 'Gerencia, jefes, supervisores, ejecutivos comerciales, vendedores, atención al cliente y personal operario.'
      }
    ],
    highLightsSummary: {
      text: 'Ofrecidos, pedidos, desplegados',
      description: [
        'Profesionales',
        'Oficios',
        'Servicios domésticos',
        'Gerencia, jefes, supervisores',
        'Ejecutivos comerciales',
        'vendedores',
        'Atención al cliente',
        'Personal operario'
      ]
    },
    discountMessage: 'Aprovecha los descuentos desde 5%, 12% y 25% a partir de 3, 5 y 10 publicaciones. Y si publicas en 3 domingos en El Comercio y El Talán el mismo día obtendrás un descuento del 33%.'
  },
  'educacion': {
    id: 3,
    order: 4,
    active: true,
    name: 'Educación',
    nameAlias: 'educacion',
    alias: CATEGORY_ALIAS.EDUCACION,
    icon: 'icon-education',
    color: COLORS.RED,
    colorRgb: 'rgba(163, 55, 61, 0.2)',
    colorRgba: '195, 69, 76',
    colorIcon: 'rgb(195,69,76,.4)',
    backgroundRgb: 'rgba(249, 241, 242, 0.9)',
    bgImage: BgEducacion,
    successImage: PaymentSuccessEducation,
    paths: {
      purchasePrint: {
        stepOne: '/publica-tu-educacion-paso-1',
        stepTypePublication: '/publica-tu-educacion-medio-de-publicacion',
        stepCalendar: '/publica-tu-educacion-calendario',
        stepExtracharge: '/publica-tu-educacion-extracargo',
        stepSummary: '/publica-tu-educacion-vista-previa',
        stepFacturation: '/publica-tu-educacion-facturacion'
      },
      consumePackage: {
        stepOne: '/publica-tu-educacion-paq-paso-1',
        stepTypePublication: '/publica-tu-educacion-paq-medio-de-publicacion',
        stepCalendar: '/publica-tu-educacion-paq-calendario',
        stepExtracharge: '/publica-tu-educacion-paq-extracargo',
        stepSummary: '/publica-tu-educacion-paq-vista-previa',
        stepFacturation: '/publica-tu-educacion-paq-facturacion',
        stepPrintPublished: '/publica-tu-educacion-paq-confirmacion-de-publicacion'
      },
      purchasePackage: {
        stepSelection: '/compra-tu-paquete-educacion',
        stepFacturation: {
          talan: '/pago-paquete-tl-educacion',
          comercioTalan: '/pago-paquete-ec-tl-educacion',
          comercio: '/pago-paquete-ec-educacion'
        },
        stepFacturationConfirm: {
          success: {
            talan: '/confirmacion-de-pago-paquete-tl-educacion',
            comercioTalan: '/confirmacion-de-pago-paquete-ec-tl-educacion',
            comercio: '/confirmacion-de-pago-paquete-ec-educacion'
          },
          pending: {
            talan: '/pendiente-de-pago-paquete-tl-educacion',
            comercioTalan: '/pendiente-de-pago-paquete-ec-tl-educacion',
            comercio: '/pendiente-de-pago-paquete-ec-educacion'
          }
        }
      },
      facebook: 'https://www.facebook.com/elcomercio.clasificados/'
    },
    textPublish: 'tu oferta educativa',
    modalExample: {
      title: 'DOCENTE UNIV',
      content: 'Requerimos docentes a tiempo completo conocimientos en programación – php - aws enviar cv: docentes@gmail.com T.987654321'
    },
    highLights: [
      {
        text: 'Universidades, Institutos, Colegios',
        description: ''
      },
      {
        text: 'Postgrados, Pregrado',
        description: ''
      },
      {
        text: 'Cursos',
        description: 'Idiomas, escolares, artísticos, informática y sistemas.'
      }
    ],
    highLightsSummary: {
      text: 'Universidades, institutos, colegios',
      description: [
        'Postgrados',
        'Pregrado',
        'Cursos',
        'Idiomas',
        'Escolares, artísticos',
        'Informática y sistemas'
      ]
    },
    discountMessage: 'Aprovecha los descuentos desde 5%, 12% y 25% a partir de 3, 5 y 10 publicaciones. Y si publicas en 3 domingos en El Comercio y El Talán el mismo día obtendrás un descuento del 33%.'
  },
  'oportunidad': {
    id: 4,
    order: 5,
    active: true,
    name: 'Oportunidades',
    nameAlias: 'oportunidades',
    alias: CATEGORY_ALIAS.OPORTUNIDAD,
    color: COLORS.VIOLET,
    icon: 'icon-idea',
    colorRgb: 'rgba(90, 75, 146, 0.2)',
    colorRgba: '90, 75, 146',
    colorIcon: 'rgb(90,75,146,.4)',
    backgroundRgb: 'rgba(243, 242, 246, 0.9)',
    bgImage: BgOportunidades,
    successImage: PaymentSuccessOportunity,
    paths: {
      purchasePrint: {
        stepOne: '/publica-tu-oportunidad-paso-1',
        stepTypePublication: '/publica-tu-oportunidad-medio-de-publicacion',
        stepCalendar: '/publica-tu-oportunidad-calendario',
        stepExtracharge: '/publica-tu-oportunidad-extracargo',
        stepSummary: '/publica-tu-oportunidad-vista-previa',
        stepFacturation: '/publica-tu-oportunidad-facturacion'
      },
      consumePackage: {
        stepOne: '/publica-tu-oportunidad-paq-paso-1',
        stepTypePublication: '/publica-tu-oportunidad-paq-medio-de-publicacion',
        stepCalendar: '/publica-tu-oportunidad-paq-calendario',
        stepExtracharge: '/publica-tu-oportunidad-paq-extracargo',
        stepSummary: '/publica-tu-oportunidad-paq-vista-previa',
        stepFacturation: '/publica-tu-oportunidad-paq-facturacion',
        stepPrintPublished: '/publica-tu-oportunidad-paq-confirmacion-de-publicacion'
      },
      purchasePackage: {
        stepSelection: '/compra-tu-paquete-oportunidades',
        stepFacturation: {
          talan: '/pago-paquete-tl-oportunidades',
          comercioTalan: '/pago-paquete-ec-tl-oportunidades',
          comercio: '/pago-paquete-ec-oportunidades'
        },
        stepFacturationConfirm: {
          success: {
            talan: '/confirmacion-de-pago-paquete-tl-oportunidades',
            comercioTalan: '/confirmacion-de-pago-paquete-ec-tl-oportunidades',
            comercio: '/confirmacion-de-pago-paquete-ec-oportunidades'
          },
          pending: {
            talan: '/pendiente-de-pago-paquete-tl-oportunidades',
            comercioTalan: '/pendiente-de-pago-paquete-ec-tl-oportunidades',
            comercio: '/pendiente-de-pago-paquete-ec-oportunidades'
          }
        }
      },
      facebook: 'https://www.facebook.com/elcomercio.clasificados/'
    },
    link: '/publica-tu-oportunidad-paso',
    linkPackage: '/compra-tu-paquete-oportunidades',
    linkFb: 'https://www.facebook.com/elcomercio.clasificados/',
    textPublish: 'diversos servicios',
    modalExample: {
      title: 'Antiguedades',
      content: 'Área cobranzas experiencia 2años disponibilidad inmediata. CV indicando pretensiones salariales selección@rrhh.com'
    },
    highLights: [
      {
        text: 'Ofrecidos y pedidos',
        description: 'Relax, objetos diversos, judiciales, operaciones de créditos, informática y sistemas, salud, belleza, mascotas, otros.'
      }
    ],
    highLightsSummary: {
      text: 'Ofrecidos y pedidos',
      description: [
        'Relax',
        'Objetos diversos',
        'Judiciales',
        'Operaciones de créditos',
        'Informática y sistemas',
        'Salud',
        'Belleza',
        'Mascota, otros'
      ]
    },
    discountMessage: 'Aprovecha los descuentos desde 5%, 12% y 25% a partir de 3, 5 y 10 publicaciones. Y si publicas en 3 domingos en El Comercio y El Talán el mismo día obtendrás un descuento del 30%.'
  }
}
